import React, { useState } from "react";
import { Popover, IconButton, Typography } from "@mui/material";
import { HelpOutline as HelpOutlineIcon } from "@mui/icons-material";

interface InfoTooltipProps {
  title: string | React.ReactNode;
  size?: number;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({ title, size = 20 }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton
        size="small"
        aria-label="More info"
        aria-haspopup="true"
        aria-expanded={Boolean(anchorEl)}
        sx={{ ml: 0.5, p: 0.25 }}
        onClick={(e) => {
          // Capture before the updater runs — React nulls currentTarget
          // after the handler returns.
          const target = e.currentTarget;
          setAnchorEl((prev) => (prev ? null : target));
        }}
      >
        <HelpOutlineIcon sx={{ fontSize: size, color: "text.secondary" }} />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: { xs: "90vw", sm: 420 },
              p: 2,
              borderRadius: 2,
            },
          },
        }}
      >
        {typeof title === "string" ? (
          <Typography
            variant="body2"
            sx={{ fontSize: "0.9375rem", lineHeight: 1.6 }}
          >
            {title}
          </Typography>
        ) : (
          title
        )}
      </Popover>
    </>
  );
};

export default InfoTooltip;
